import React, { useEffect, useState, useRef } from 'react';
import PageLayout from 'components/layouts/PageLayout';
import NewButton from 'components/input/NewButton';
import { Box, Tabs } from '@mui/material';
import styled from 'styled-components';
import { Tab } from '@mui/material';
import { useStoreWrapper } from 'stores/StoreHelper';
import RichEditor from 'components/editor/RichEditor';
import { Button } from 'saladsoft-primitive';
import ServiceHelper from 'stores/ServiceHelper';
import { AdminSystemLocaleDto, AdminTermRequestDto } from 'services/data-contracts';
import { toast } from 'react-toastify';
import TermsContainer from 'containers/TermsContainer';

const PrivacySettingsPage = () => {
  //   const { languageStore } = useStoreWrapper();

  //   const [value, setValue] = React.useState(0);
  //   const [languages, setLanguages] = useState<AdminSystemLocaleDto[]>([]);
  //   const [editorContents, setEditorContents] = useState<{ [key: string]: string }>({});

  //   const editorTitleRef = useRef<{ [key: string]: string }>({});
  //   const editorContentRef = useRef<{ [key: string]: string }>({});

  //   const getLanguage = async () => {
  //     const r = ServiceHelper.adminLocaleService?.getLocales1().then((res) => {
  //       const activeLocales = res.data?.filter((locale) => locale.isActive);
  //       setLanguages(activeLocales);
  //     });
  //     // const response = (await languageStore.getLanguage()) as any as {
  //     //   code: string;
  //     //   title: string;
  //     // }[];
  //   };

  //   const handleChange = (event: React.SyntheticEvent, newValue: number) => {
  //     setValue(newValue);
  //   };

  //   const handleEditorChange = (
  //     content: string | undefined,
  //     language: string,
  //     type: 'title' | 'content',
  //   ) => {
  //     if (content === undefined) return;

  //     if (type === 'title') {
  //       editorTitleRef.current = {
  //         ...editorTitleRef.current,
  //         [language]: content,
  //       };
  //     } else {
  //       editorContentRef.current = {
  //         ...editorContentRef.current,
  //         [language]: content,
  //       };
  //     }
  //   };

  //   function a11yProps(index: number) {
  //     return {
  //       id: `simple-tab-${index}`,
  //       'aria-controls': `simple-tabpanel-${index}`,
  //     };
  //   }

  //   const handleSave = () => {
  //     console.log('editorContents', editorContentRef);
  //     const contents: AdminTermRequestDto = {
  //       localizedTitle: editorTitleRef.current,
  //       localizedContent: editorContentRef.current,
  //     };

  //     ServiceHelper?.adminTermsService?.saveTerm('PRIVACY_POLICY', contents).then((res) => {
  //       if (res?.status === 200) {
  //         toast.success('개인정보처리방침이 저장되었습니다.');
  //       }
  //     });
  //   };

  //   useEffect(() => {
  //     // 각 언어별 제목 번역
  //     const initialTitles: { [key: string]: string } = {
  //       ko: '개인정보처리방침',
  //       en: 'Privacy Policy',
  //       ja: 'プライバシーポリシー',
  //       zh: '隐私政策',
  //     };

  //     const initialContents: { [key: string]: string } = {};

  //     languages.forEach((code) => {
  //       // 지원하지 않는 언어코드가 있을 경우 영어로 기본 설정
  //       if (!initialTitles[code?.locale!]) {
  //         initialTitles[code?.locale!] = initialTitles['en'];
  //       }
  //       initialContents[code?.locale!] = '';
  //     });

  //     editorTitleRef.current = initialTitles;
  //     editorContentRef.current = initialContents;
  //   }, [languages]);

  //   useEffect(() => {
  //     getLanguage();
  //     ServiceHelper?.adminTermsService?.getTermByCategory1('PRIVACY_POLICY').then((res) => {
  //       if (res?.data?.localizedTitle && res?.data?.localizedContent) {
  //         editorTitleRef.current = res.data.localizedTitle;
  //         setEditorContents(res.data.localizedContent);
  //         editorContentRef.current = res.data.localizedContent;
  //       }
  //     });
  //   }, []);

  const title = {
    ko: '개인정보처리방침',
    en: 'Privacy Policy',
    ja: 'プライバシーポリシー',
    zh: '隐私政策',
  };

  return (
    <PageLayout title="개인정보 처리방침 설정">
      <TermsContainer type="PRIVACY_POLICY" title={title} />
    </PageLayout>
  );
};

const LocalTabPanel = styled.div<{ show: boolean }>`
  padding: 30px;
  display: ${({ show }) => (show ? 'block' : 'none')};
`;

export default PrivacySettingsPage;
